import { logout } from '@/model/info-model'
import { MessageBox } from 'element-ui'
let alertUnauthorizedFlag = false
// axios 默认配置
export default (axios) => {
  axios.defaults.timeout = 1000 * 60 * 15
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
  axios.defaults.headers.post['app-client-id'] = 'webApp'
  axios.defaults.headers.post['app-client-secret'] = 'webApp'

  axios.defaults.headers.get['Content-Type'] = 'application/json;charset=UTF-8'
  axios.defaults.headers.get['app-client-id'] = 'webApp'
  axios.defaults.headers.get['app-client-secret'] = 'webApp'

  axios.defaults.baseURL = window.location.protocol + '//' + window.location.host

  axios.defaults.retry = 1
  let searchUserId = location.search.split('userId=')[1] ? { userId: location.search.split('userId=')[1].split('&')[0] } : null
  let userInfo = JSON.parse(sessionStorage.getItem('user_info')) || searchUserId || (top.GLOBAL ? top.GLOBAL.user : null) || {}
  // 添加请求拦截器
  axios.interceptors.request.use(function (config) {
    // 单点登录的话 初始化时 userInfo是不存在的, 要在单点登录成功后才能获取userId 会导致获取不到userId问题 在请求时判断如果userInfo是空 再获取一次
    userInfo = userInfo && userInfo.userId ? userInfo : (JSON.parse(sessionStorage.getItem('user_info')) || searchUserId || (top.GLOBAL ? top.GLOBAL.user : null) || {})
    let tokenStr = 'Bearer ' + localStorage.getItem(`kw_token-${userInfo.userId}`)
    config.headers.delete['Authorization'] = tokenStr
    config.headers.post['Authorization'] = tokenStr
    config.headers.get['Authorization'] = tokenStr
    if (config.url.indexOf('resource.kaow.cn') === -1 && config.url.indexOf('localhost') === -1) {
      config.headers.post['Authorization'] = tokenStr
      config.headers.delete['Authorization'] = tokenStr
      config.headers.get['Authorization'] = tokenStr
    } else {
      delete config.headers.get.Authorization
      delete config.headers.get['app-client-id']
      delete config.headers.get['app-client-secret']
    }
    // 如果unAuth为1，则不带token
    if (config.unAuth === 1) {
      delete config.headers.delete['Authorization']
      delete config.headers.post['Authorization']
      delete config.headers.get['Authorization']
      delete config.headers.get['app-client-id']
      delete config.headers.get['app-client-secret']
      delete config.headers.post['app-client-id']
      delete config.headers.post['app-client-secret']
      delete config.headers.delete['app-client-id']
      delete config.headers.delete['app-client-secret']
    }
    return config
  }, function (error) {
    return Promise.reject(error)
  })

  // 添加响应拦截器
  axios.interceptors.response.use(function (response) {
    // console.log(response)
    return response
  }, function (error) {
    // let config = error.config
    if (error.response && error.response.status === 401) {
      MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).then(() => {
        logout().then(() => {
          sessionStorage.removeItem('login_validate_id')
          localStorage.removeItem(`kw_token-${userInfo.userId}`)
          localStorage.removeItem('kw_refresh_token')
          window.location.href = '/index.html'
        }).catch(err => {
          console.log(err)
          sessionStorage.removeItem('login_validate_id')
          localStorage.removeItem(`kw_token-${userInfo.userId}`)
          localStorage.removeItem('kw_refresh_token')
          window.location.href = '/index.html'
        })
      }).catch(() => {})
      return Promise.reject(error)
      // let refreshTokenFlag = localStorage.getItem('refresh_token_flag')
      // if (refreshTokenFlag != null && refreshTokenFlag) {
      //   let expiresIn = localStorage.getItem('expires_in')
      //   let tokenTime = localStorage.getItem('token_time')
      //   let def = (new Date() - new Date(tokenTime)) / 1000
      //   config.retryCont = config.retryCont || 0
      //   if (config.retryCont >= config.retry) {
      //     return Promise.reject(error)
      //   }
      //   config.retryCont++
      //   if (expiresIn - def < 300) {
      //     let refreshToken = localStorage.getItem('kw_refresh_token')
      //     localStorage.setItem('refresh_token_flag', false)
      //     let refreshUrl = `/AuthService/oauth/token?grant_type=refresh_token&refresh_token=${refreshToken}&client_id=webApp&client_secret=webApp`
      //     return axios.post(refreshUrl, '').then((refreshRes) => {
      //       localStorage.setItem('kw_refresh_token', refreshRes.data.refresh_token)
      //       localStorage.setItem('kw_token', refreshRes.data.access_token)
      //       localStorage.setItem('token_time', new Date())
      //       localStorage.setItem('expires_in', refreshRes.data.expires_in)
      //       localStorage.setItem('refresh_token_flag', true)
      //     }).then(() => {
      //       config.headers.Authorization = 'Bearer ' + localStorage.getItem('kw_token')
      //       let backoff = new Promise(function (resolve) {
      //         setTimeout(function () {
      //           resolve()
      //         }, config.retryDelay || 1)
      //       })
      //       return backoff.then(function () {
      //         return axios(config)
      //       })
      //     })
      //   }
      // }
    } else if (error.response && error.response.status === 400) {
      // document.location.href = window.document.location.origin
    } else {
      return Promise.reject(error)
    }
  })
}



// WEBPACK FOOTER //
// ./src/config/axios-config.js